var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        value: _vm.isOpen,
        title: "Edit Image Effect",
        scrollable: false,
      },
      on: { ok: _setup.handleClose, closed: _setup.handleClose },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                [
                  _c(_setup.CButton, {
                    attrs: { text: "Cancel", variant: "secondary" },
                    on: { click: _setup.handleClose },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(_setup.CButton, {
                    attrs: { text: "Save", variant: "primary" },
                    on: { click: _setup.handleSave },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "form",
        {
          staticClass: "space-y-4",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _setup.handleSave.apply(null, arguments)
            },
          },
        },
        [
          _setup.currentEffectComponent
            ? _c(_setup.currentEffectComponent, {
                tag: "component",
                attrs: { "image-effect": _setup.formData },
                on: {
                  "update:image-effect": function ($event) {
                    _setup.formData = $event
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }